import React, { useEffect } from "react";
import OffersPromotions from "./OffersPromotions/OffersPromotions";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./OffersPromotions/OffersPromotions.css";
import AOS from "aos";
import "aos/dist/aos.css";
import ServiceCards from "./OffersPromotions/Services Cards/ServicesCards"
const ShoeCare = "/images/home/2150847378.jpg";
const ShirtsPlan = "/images/home/tshit.jpg";
const ORDER = "/images/home/ORDER.png";
const dryclean = "/images/home/What-is-dry-cleaning-1-1200x596.jpg"
const bagclean ="/images/home/bag-dry-clean.jpg"
export default function Laundryoffers() {
  useEffect(() => {
    AOS.init({
      duration: 1200,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

    const DirhamIcon = () => (
    <svg width="14" height="14" viewBox="0 0 100 100">
      <path
        d="M20 10 L20 90 Q80 90 80 50 Q80 10 20 10"
        stroke="white"
        strokeWidth="10"
        fill="none"
      />
      <line x1="20" y1="40" x2="100" y2="40" stroke="white" strokeWidth="10" />
      <line x1="20" y1="60" x2="100" y2="60" stroke="white" strokeWidth="10" />
    </svg>
  );
  return (
    <div className="Container-fluid py-5">

      {/* TOP SECTION */}
      <OffersPromotions />

      {/* SECTION 1 */}
      <section className="shoecare-section" data-aos="fade-up">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} data-aos="fade-right">
              <h1>
                Fresh Clean ShoeCare <span>25%</span>
              </h1>
              <h5 className="mt-3">Revive your shoes with Fresh Clean</h5>

              <div className="offer-text">
                <p>
                  Get your branded shoes cleaned and restored by experts.
                  Book now and get 25% cashback on your first order.
                </p>

                <p className="tcs">T&Cs Apply</p>

                <ul className="offer-list">
                  <li>Valid for first order only</li>
                  <li>No other discounts applicable</li>
                  <li>5 days service turnaround</li>
                </ul>
              </div>

              <Button className="offer-btn mt-3">Get Offer</Button>
            </Col>

            <Col lg={6} className="image-col" data-aos="fade-left">
              <img src={ShoeCare} alt="" className="banner-img" />
            </Col>
          </Row>
        </Container>
      </section>

      {/* SECTION 2 */}
      <section className="shoecare-section" data-aos="fade-up">
        <Container>
          <Row className="align-items-center">

            <Col lg={6} className="image-col" data-aos="fade-right">
              <img src={ShirtsPlan} alt="" className="banner-img" />
            </Col>

            <Col lg={6} data-aos="fade-left">
              <h1>The New 50 Shirts Plan <span>25%</span></h1>
              <h5 className="mt-3">Perfect for daily wear</h5>

              <div className="offer-text">
                <p>
                  Perfect for users who love crisp shirts and polo shirts. Try the new prepaid 50 Shirts plan from  valid for three months at 
                  
                  3.0<DirhamIcon/>per shirt. Pay once and book pick up of your shirts whenever you need it. Simple.
                </p>

                <p className="tcs">T&Cs Apply</p>

                <ul className="offer-list">
                  <li>Valid for 3 months</li>
                  <li>Clean & Press service</li>
                  <li>No cashback applicable</li>
                </ul>
              </div>

              <Button className="offer-btn mt-3">Get Offer</Button>
            </Col>
          </Row>
        </Container>
      </section>

      {/* SECTION 3 */}
      <section className="shoecare-section" data-aos="fade-up">
        <Container>
          <Row className="align-items-center">

            <Col lg={6} data-aos="fade-right">
              <h1><span>25%</span> Cashback First Order</h1>

              <div className="offer-text">
                <p>
                  Experience eco-friendly services from #1 trusted laundry and dry cleaning brand in the world.


                </p>
                <p className="tcs">T&Cs Apply</p>

                <ul className="offer-list">
                  <li>Applicable for new customers only
                  </li>
                  <li>Offer cannot be used in conjunction with other offers, discounts, promotions or cashback offers
                  </li>
                  <li>
                    Not valid Carpet Cleaning pick up service, Gown preservation service, Alterations Services and Wash & Fold, Linen Care
                  </li>
                </ul>
              </div>

              <Button className="offer-btn mt-3">Get Offer</Button>
            </Col>

            <Col lg={6} className="image-col" data-aos="fade-left">
              <img
                src={dryclean}
                alt=""
                className="banner-img"
              />
            </Col>
          </Row>
        </Container>
      </section>




      {/* SECTION 4 */}
      <section className="shoecare-section" data-aos="fade-up">
        <Container>
          <Row className="align-items-center">

            <Col lg={6} className="image-col" data-aos="fade-right">
              <img src={bagclean} alt="" className="banner-img" />
            </Col>

            <Col lg={6} data-aos="fade-right">
              <h1><span>25%</span>fresh clean BagCare</h1>

              <div className="offer-text">
                <p>
                  Give your bags a Reju venating staycation at fresh clean
                  Get your luxury bags cleaned and immaculately restored by the experts Book your order across Dubai and Abu Dhabi and enjoy 25% Cashback on your first BagCare service today.

                </p>
                <p className="tcs">T&Cs Apply</p>

                <ul className="offer-list">
                  <li>25% Cashback valid for first BagCare order
                  </li>
                  <li>
                    Partnership & Loyalty discounts not applicable

                  </li>
                  <li>
                    5% Cashback rewards not applicable</li>
                  <li>
                    7 days service turnaround
                  </li>
                </ul>
              </div>

              <Button className="offer-btn mt-3">Get Offer</Button>
            </Col>

          </Row>
        </Container>
      </section>










      {/* SECTION 2 */}


<ServiceCards />
      {/* FLOATING SCROLL BUTTON */}
      <div className="scroll-indicator">↓ Scroll</div>

    </div>
  );
}